import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'ui';

const NoDeviceButton = ({ navigate, stopPolling }) => (
    <Button
        onClick={() => {
            stopPolling();
            navigate('/verification', { state: { noDevice: true } });
        }}
        block
        variant="link"
    >
        Don't have a valid ID or passport?
    </Button>
);

NoDeviceButton.propTypes = {
    navigate: PropTypes.func.isRequired,
    stopPolling: PropTypes.func.isRequired,
};

export default NoDeviceButton;
